export default {"src":"/_next/static/media/hashicorp-horizontal_on-light.3a0177b7.svg","height":62,"width":254,"blurWidth":0,"blurHeight":0};